export default __webpack_public_path__ + "static/media/t21.f05851ae.jpg";